// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__iklRf","title":"styles_title__k-O4L","table":"styles_table__44tPf"};